// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__17UFW","inner":"Footer_inner__2LVH3"};